<template>
  <div class="AddOrg addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave">{{$t('LanguageLib.SAVE')}}</el-button>
        <p class="drawerText">{{$t('LanguageLib.SERIAL_NUMBER')}}</p>
        <el-form-item>
          <el-input
            oninput="this.value=this.value.replace(/[^\d]/g,'');"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            :maxlength="9"
            v-model="ruleForm.addsortNumber"
          >
          </el-input>
        </el-form-item>
        <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.NAME_OF_ASSOCIATION')}}</p>
        <el-form-item prop="addorgName" style="position: relative;white-space: nowrap;">
          <el-input
            maxlength="50"
            @keyup.native="btKeyUp"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="ruleForm.addorgName"
          >
          </el-input>
          <span v-if="wxDepartmentId && JSON.parse($commonfun.localStorage.getitem('qyuser')) && showQyOrgName" style="cursor: no-drop;display: inline-block;width: 318px;height: 38px;position: absolute;left: 1px;top: 1px;background-color: #f5f7fa;border-radius: 5px;">
            <ww-open-data style="position: absolute;top: 1px;left: 14px;background: #f5f7fa;height: 30px;width: 302px;overflow: hidden;" type="departmentName" :openid="wxDepartmentId"></ww-open-data>
          </span>
          <span v-if="wxDepartmentId && !JSON.parse($commonfun.localStorage.getitem('qyuser')) && showQyOrgName" style="cursor: no-drop;display: inline-block;width: 318px;height: 38px;position: absolute;left: 1px;top: 1px;background-color: #f5f7fa;border-radius: 5px;">
            <span style="position: absolute;top: 1px;left: 14px;background: #f5f7fa;height: 30px;width: 302px;overflow: hidden;">wx|{{wxDepartmentId}}</span>
          </span>
          <div style="display: inline-block;position: absolute;height: 40px;">
            <el-checkbox v-if="wxDepartmentId" v-model="showQyOrgName" style="margin-left: 10px;line-height: 20px;position: absolute;top: 0;">{{$t('LanguageLib.SHOW_QY_DEPARTMENTNAME')}}</el-checkbox>
            <p v-if="$commonfun.localStorage.getitem('qyuser') === 'true' && wxDepartmentId" style="position: absolute;font-size: 12px;font-weight: 400;color: rgb(144, 147, 153);line-height: 20px;top: 20px;left: 10px;"><span>{{$t('LanguageLib.QY_DEPARTMENTNAME')}}:</span>&nbsp;&nbsp;<span v-html="$commonfun.RenderWxName('departmentName', 'wx|' + wxDepartmentId)">></span></p>
            <p v-if="$commonfun.localStorage.getitem('qyuser') === 'false' && wxDepartmentId" style="position: absolute;font-size: 12px;font-weight: 400;color: rgb(144, 147, 153);line-height: 20px;top: 20px;left: 10px;"><span>{{$t('LanguageLib.QY_DEPARTMENTNAME')}}:</span>&nbsp;&nbsp;<span>{{$t('LanguageLib.QY_CANNOT_GET')}}</span></p>
          </div>
        </el-form-item>
        <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.ORGANIZATION_TYPE')}}</p>
        <el-form-item  prop="addorgTypeid">
          <el-select style="width: 320px;" filterable v-model="ruleForm.addorgTypeid" :disabled="!OrgDetail.isUserDefined && !OrgDetail.allowSelect" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
            <el-option
              v-for="item in OrgTypeList"
              :key="item.id"
              :label="item.domainTypeName"
              :value="item.id">
            </el-option>
          </el-select>
          <span :title="OrgDetail.domainTypeName" v-if="!OrgDetail.isUserDefined && !OrgDetail.allowSelect" style="padding-left:15px;cursor: no-drop;display: inline-block;width: 270px;height: 38px;position: absolute;left: 1px;top: 1px;background-color: #f5f7fa;border-radius: 5px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ OrgDetail.domainTypeName }}</span>
        </el-form-item>
        <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.PARENT_ORGANIZATION')}}</p>
        <el-form-item prop="addparentName" style="position: relative">
          <el-input
            style="width: 320px;"
            class="TeInput"
            :readonly="true"
            v-model="ruleForm.addparentName"
          >
           <el-button @click="openOrgList" slot="append" :style="styleStr" icon="el-icon-more"></el-button>
          </el-input>
          <span v-if="wxDepartmentId && (ruleForm.addparentName.slice(0, 3) === 'wx|') && JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="display: inline-block;width: 248px;height: 38px;position: absolute;left: 1px;top: 1px;border-radius: 5px;">
            <ww-open-data style="position: absolute;top: 1px;left: 14px;background: #fff;height: 36px;width: 232px;overflow: hidden;"  type="departmentName" :openid="ruleForm.addparentName.slice(3)"></ww-open-data>
          </span>
          <ww-open-data :style="ruleForm.addparentName.slice(0, 3) === 'wx|' ? 'z-index: 999;' : 'z-index:-1;'" v-if="!wxDepartmentId && (ruleForm.addparentName.slice(0, 3) === 'wx|') && JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="position: absolute;top: 1px;left: 14px;background: #fff;height: 30px;width: 232px;overflow: hidden;"  type="departmentName" :openid="ruleForm.addparentName.slice(3)"></ww-open-data>
        </el-form-item>
        <p class="drawerText">{{$t('LanguageLib.REMARK2')}}</p>
        <el-input
        style="width: 320px;margin-bottom: 15px;"
          maxlength="200"
          type="textarea"
          :rows="3"
          placeholder=""
          resize="none"
          v-model="addremark"
        >
        </el-input>
      </el-form>
    </div>
    <el-dialog :title="$t('LanguageLib.SelectOrganization')" :visible.sync="dialogTableVisible" width="360px !important">
      <DomainTree @addcheck-treedata="getTreeCheckData" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
      <el-button style="float:right;margin-top:15px;" @click="keepOrgData" type="primary" class="searchBtn">{{$t('LanguageLib.DETERMINE')}}</el-button>
    </el-dialog>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import DomainTree from '@/components/DomainTree.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'AddOrg',
  components: { DomainTree },
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedSelectData', 'searchDescContent', 'searchOrgName', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    var checkOrgName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.NAME_OF_ASSOCIATION') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.NAME_OF_ASSOCIATION') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    var checkOrgType = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.ORGANIZATION_TYPE') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    var checkParentOrg = (rule, value, callback) => {
      if (!value) {
        this.styleStr = 'width: 70px;border-bottom: 1px solid #F56C6C;border-top: 1px solid #F56C6C;border-right: 1px solid #F56C6C;border-radius: 0 4px 4px 0;background-color: #D8DCE6;'
        return callback(new Error(this.$t('LanguageLib.PARENT_ORGANIZATION') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        this.styleStr = 'width: 70px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;'
        callback()
      }
    }
    return {
      showQyOrgName: false, // 是否显示企微部门名称
      wxDepartmentId: 0, // 企微部门id
      OrgDetail: {
        isUserDefined: true
      },
      titleType: this.$t('LanguageLib.NewOrganization'),
      styleStr: 'width: 70px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;',
      dialogTableVisible: false, // 组织树视图的显示和隐藏
      OrgTypeList: [],
      addremark: '',
      orgData: [],
      orgTreeData: [],
      oneNodeArr: [],
      addparentId: '',
      addCheckparentName: '',
      addCheckparentId: '',
      addCheckDomainNo: '',
      editDomainNo: '',
      ruleForm: {
        addsortNumber: '',
        addorgName: '',
        addorgTypeid: '',
        addparentName: ''
      },
      rules: {
        addorgName: [
          { validator: checkOrgName, trigger: 'blur' }
        ],
        addorgTypeid: [
          { validator: checkOrgType, trigger: 'change' }
        ],
        addparentName: [
          { validator: checkParentOrg, trigger: 'change' }
        ]
      },
      loadingSave: false // 保存按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    if (to.query.type === 'edit') {
      basicdataApi.getOrgDetail('get', '/sysdomain/domainDetail',
        {
          id: to.query.id
        })
        .then(res => {
          NProgress.done()
          next(vm => {
            vm.OrgDetail = res.data.domainType
            vm.ruleForm.addsortNumber = res.data.sortNo
            if (res.data.domainName) {
              res.data.domainName.indexOf('wx|') >= 0 ? vm.showQyOrgName = true : vm.showQyOrgName = false
              vm.ruleForm.addorgName = res.data.domainName.replace('wx|', '')
            } else {
              vm.ruleForm.addorgName = res.data.domainName
            }
            vm.addremark = res.data.description
            vm.ruleForm.addparentId = res.data.parentDomainId
            vm.editDomainNo = res.data.domainNo
            vm.wxDepartmentId = res.data.wxDepartmentId
            // 获取组织类型列表
            basicdataApi.DelOrgTypeDataList('get', '/sysdomain/domainType', {
              pageIndex: 1,
              pageSize: 2147483647
            })
              .then(value => {
                var OrgTypeList = []
                for (var i in value.data) {
                  if (value.data[i].isUserDefined || value.data[i].allowSelect) {
                    OrgTypeList.push(value.data[i])
                  }
                }
                vm.OrgTypeList = OrgTypeList
                vm.ruleForm.addorgTypeid = res.data.domainTypeId
              })
              .catch(err => {
                this.$commonfun.console.log(err)
              })
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    } else {
      // 获取组织类型列表
      basicdataApi.DelOrgTypeDataList('get', '/sysdomain/domainType', {
        pageIndex: 1,
        pageSize: 2147483647
      })
        .then(value => {
          NProgress.done()
          next(vm => {
            vm.ruleForm.addparentId = to.query.checkDomainId
            var OrgTypeList = []
            for (var i in value.data) {
              if (value.data[i].isUserDefined || value.data[i].allowSelect) {
                OrgTypeList.push(value.data[i])
              }
            }
            vm.OrgTypeList = OrgTypeList
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    }
  },
  created () {
    this.titleType = this.$route.query.type === 'add' ? this.$t('LanguageLib.NewOrganization') : this.$t('LanguageLib.EditOrganization')
    // 获取组织树列表
    basicdataApi.gettreelist('get', '/sysdomain/domainTree')
      .then(res => {
        this.orgData = res.data
        this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
        this.oneNodeArr.push(this.orgTreeData[0].id)
        for (let i = 0; i < this.orgData.length; i++) {
          if (this.orgData[i].id === this.ruleForm.addparentId) {
            this.ruleForm.addparentName = this.orgData[i].domainName
            this.addCheckparentId = this.ruleForm.addparentId
          }
        }
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
    // 获取组织序号
    basicdataApi.SortNo('get', '/sysdomain/sortNo')
      .then(res => {
        if (this.$route.query.type === 'add') {
          this.ruleForm.addsortNumber = res.data
        }
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
  },
  methods: {
    // 去除组织名称的特殊字符
    btKeyUp (e) {
      e.target.value = e.target.value.replace(/[\\/:：*?？"<>|]/g, '')
    },
    // 返回
    goReturn () {
      this.$router.push('/basicdata/domainsetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&checkedSelectData=' + this.$route.query.checkedSelectData + '&searchDescContent=' + this.$commonfun.encodeUrl(this.$route.query.searchDescContent) + '&searchOrgName=' + this.$commonfun.encodeUrl(this.$route.query.searchOrgName) + '&fromPath=addorg')
    },
    // 打开组织树视图
    openOrgList () {
      this.dialogTableVisible = true
    },
    // 树组件传过来的数据
    getTreeCheckData (data) {
      this.addCheckparentName = data.domainName
      this.addCheckparentId = data.id
      this.addCheckDomainNo = data.domainNo
    },
    // 保存树数据
    keepOrgData () {
      if (this.$route.query.fromQy === 'true') {
        this.$commonfun.confirm(this.$t('LanguageLib.UPDATE_ORGANIZATION_PARENT_WARNING'), this.$t('LanguageLib.PROMPT'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
          .then(() => {
            if (this.$route.query.type === 'add') {
              this.dialogTableVisible = false
              this.addparentId = this.addCheckparentId
              this.ruleForm.addparentName = this.addCheckparentName
            } else {
              if (this.addCheckDomainNo.slice(0, this.editDomainNo.length) !== this.editDomainNo) {
                this.dialogTableVisible = false
                this.addparentId = this.addCheckparentId
                this.ruleForm.addparentName = this.addCheckparentName
              } else {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.NoSelectMsg1')
                })
              }
            }
          }).catch(() => {
            this.dialogTableVisible = false
          })
      } else {
        if (this.$route.query.type === 'add') {
          this.dialogTableVisible = false
          this.addparentId = this.addCheckparentId
          this.ruleForm.addparentName = this.addCheckparentName
        } else {
          if (this.addCheckDomainNo.slice(0, this.editDomainNo.length) !== this.editDomainNo) {
            this.dialogTableVisible = false
            this.addparentId = this.addCheckparentId
            this.ruleForm.addparentName = this.addCheckparentName
          } else {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.NoSelectMsg1')
            })
          }
        }
      }
    },
    // 保存数据
    submit (formName) {
      if (this.showQyOrgName && this.wxDepartmentId) {
        this.ruleForm.addorgName = 'wx|' + this.wxDepartmentId
      } else {
        if (this.$route.query.type === 'edit') {
          if (this.ruleForm.addorgName.indexOf('wx|') === -1) {
            this.ruleForm.addorgName = this.ruleForm.addorgName.replace(/[\\/:：*?？"<>|]/g, '')
          }
        } else {
          this.ruleForm.addorgName = this.ruleForm.addorgName.replace(/[\\/:：*?？"<>|]/g, '')
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          if (this.$route.query.type === 'add') {
            basicdataApi.AddOrgData('post', '/sysdomain/add', {
              DomainName: this.$commonfun.trim('tail', this.ruleForm.addorgName),
              DomainTypeId: this.ruleForm.addorgTypeid,
              ParentDomainId: this.addCheckparentId,
              Description: this.$commonfun.trim('tail', this.addremark),
              SortNo: this.ruleForm.addsortNumber === '' ? null : this.ruleForm.addsortNumber * 1
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
                })
                this.$router.push('/basicdata/domainsetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&checkedSelectData=' + this.$route.query.checkedSelectData + '&searchDescContent=' + this.$commonfun.encodeUrl(this.$route.query.searchDescContent) + '&searchOrgName=' + this.$commonfun.encodeUrl(this.$route.query.searchOrgName) + '&fromPath=addorg')
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          } else {
            basicdataApi.EditOrgData('post', '/sysdomain/edit', {
              DomainName: this.$commonfun.trim('tail', this.ruleForm.addorgName),
              DomainTypeId: this.ruleForm.addorgTypeid,
              ParentDomainId: this.addCheckparentId,
              Description: this.$commonfun.trim('tail', this.addremark),
              SortNo: this.ruleForm.addsortNumber === '' ? null : this.ruleForm.addsortNumber * 1,
              id: this.$route.query.id
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.EditSuccess')
                })
                this.$router.push('/basicdata/domainsetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&checkDomainId=' + this.$route.query.checkDomainId + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&checkedSelectData=' + this.$route.query.checkedSelectData + '&searchDescContent=' + this.$commonfun.encodeUrl(this.$route.query.searchDescContent) + '&searchOrgName=' + this.$commonfun.encodeUrl(this.$route.query.searchOrgName) + '&fromPath=addorg')
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          }
        } else {
          return false
        }
      })
    }
  },
  watch: {
    showQyOrgName (value) {
      if (value) {
        this.ruleForm.addorgName = this.wxDepartmentId + ''
      }
    }
  }
}
</script>

<style lang="scss">
.AddOrg{
  .left{
    background: #fff;
    width:  320px;
    float: left;
    height: 100%;
    border-right: 1px solid #f2f2f2;
    .treeBox {
      height: 485px;
    }
  }
  .TeInput input{
    border-right: 0px;
    border-radius: 4px 0 0 4px;
  }
  .return{
    padding-left: 25px;
    position: relative;
    height:50px;
    background:rgba(255,255,255,1);
    line-height: 50px;
    border-bottom: 1px solid #F2F2F2;
    .el-icon-back{
      margin-right: 15px;
      cursor: pointer;
    }
    .border{
      position: absolute;
      height: 37px;
      border-left: 1px solid #f1f1f1;
      display: inline-block;
      top: 5px;
    }
    .title{
      height:25px;
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin-left: 15px;
    }
  }
  .content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 5px;
    background: #fff;
  }
  .content{
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    width: 100%;
    height: calc( 100% - 50px);
    overflow-y: auto;
    padding-left: 100px;
    padding-top: 15px;
    .drawerText{
      margin-bottom: 5px;
      height:16px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:16px;
    }
  }
  // 修改按钮样式
  .el-button--primary{
    background-color: #3BC6B9;
    border-color: #3BC6B9;
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  .colorRed{
    color: red;
  }
  // 组织树视图
  .el-dialog{
    overflow: hidden;
  }
  .el-textarea__inner{
    font: 400 14px Arial;
  }
  .el-input .is-disabled{
    color: #2c3e50;
  }
}
</style>
